<template>
  <div v-show="isMobile">
    <div class="mobile-bottom-bar">
      <!-- 左侧：用户状态 -->
      <div class="bar-left">
        <div class="bar-left-top">
          <div class="user-avatar" v-if="avatarReady">
            <div class="avatar-layer" :style="{backgroundImage:'url(' + ossPath + headerFace + ')'}"></div>
            <div class="avatar-layer" :style="{backgroundImage:'url(' + ossPath + headerEye + ')'}"></div>
            <div class="avatar-layer" :style="{backgroundImage:'url(' + ossPath + headerMouth + ')'}"></div>
            <div class="avatar-layer" :style="{backgroundImage:'url(' + ossPath + headerHair + ')'}"></div>
          </div>
          <div class="user-avatar placeholder" v-else></div>
          <div class="name-area">
            <div class="name-line">
              <span class="user-nickname">{{ userNickName || userName || '冒险者' }}</span>
              <span class="user-account">({{ userName }})</span>
            </div>
            <div class="tag-line">
              <span class="tag lv">Lv.{{ userLevel || 1 }}</span>
              <span class="tag money">💰{{ userMoney || 0 }}</span>
            </div>
          </div>
        </div>
        <div class="bar-left-mid">
          <div class="bar-wrap">
            <div class="bar-bg bar-stamina">
              <div class="bar-fill" :style="{width: staminaPct + '%'}"></div>
              <span class="bar-text">{{ staminaNow }}/{{ staminaMax }}</span>
            </div>
          </div>
          <div class="bar-wrap">
            <div class="bar-bg bar-fatigue">
              <div class="bar-fill" :style="{width: fatiguePct + '%'}"></div>
              <span class="bar-text">{{ fatigueNow }}/{{ fatigueMax }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 中间：罗盘插槽 -->
      <div class="bar-center">
        <slot name="compass"></slot>
      </div>

      <!-- 右侧：播放器占位 -->
      <div class="bar-right"></div>
    </div>

    <!-- 经验条：独立固定在最底部 -->
    <div class="exp-bar-outer">
      <div class="bar-bg bar-exp">
        <div class="bar-fill" :style="{width: expPct + '%'}"></div>
        <span class="bar-text">{{ expText }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
  name: 'MobileBottomBar',
  data() {
    return {
      isMobile: window.innerWidth <= 768,
    };
  },
  computed: {
    ...mapState('user', ['fantasyUserBO', 'fantasyUserDetail', 'userHeader']),
    ossPath() {
      // 兜底值与 main.js 保持一致：走入口层同源反代（原因见 main.js 的 ossPath 注释）
      return this.$root.ossPath || '/oss/';
    },
    userName() {
      return this.fantasyUserBO.userName || '';
    },
    userNickName() {
      return this.fantasyUserBO.nickName || this.fantasyUserBO.userName || '';
    },
    userId() {
      return this.fantasyUserBO.id || '';
    },
    userLevel() {
      return this.fantasyUserDetail.level || 1;
    },
    userMoney() {
      return this.fantasyUserDetail.money ? Number(this.fantasyUserDetail.money).toFixed(0) : 0;
    },
    staminaNow() {
      return this.fantasyUserDetail.strength || 0;
    },
    staminaMax() {
      return this.fantasyUserDetail.strengthtop || 100;
    },
    fatigueNow() {
      return this.fantasyUserDetail.exhaustion || 0;
    },
    fatigueMax() {
      return this.fantasyUserDetail.exhaustionTop || 100;
    },
    // 经验条=本级进度（后端派生字段 levelExp/levelExpTop：升级后从 0 起算，升级动作的溢出自动计入）；
    // levelExpTop=0 为满级；派生字段缺省时回退旧口径，兼容前后端发布过渡期
    userExp() {
      const d = this.fantasyUserDetail || {};
      return d.levelExp != null ? d.levelExp : (d.exp || 0);
    },
    userUpgradeExp() {
      const d = this.fantasyUserDetail || {};
      return d.levelExpTop != null ? d.levelExpTop : (d.nextexp || 0);
    },
    isMaxLevel() {
      return (this.fantasyUserDetail || {}).levelExpTop === 0;
    },
    expText() {
      if (this.isMaxLevel) return '满级';
      return (this.userExp || 0) + '/' + (this.userUpgradeExp || 0);
    },
    headerFace() {
      return this.userHeader.faceUrl || '';
    },
    headerEye() {
      return this.userHeader.eyeUrl || '';
    },
    headerMouth() {
      return this.userHeader.mouthUrl || '';
    },
    headerHair() {
      return this.userHeader.hairUrl || '';
    },
    avatarReady() {
      return !!(this.userHeader.faceUrl || this.userHeader.eyeUrl || this.userHeader.mouthUrl || this.userHeader.hairUrl);
    },
    staminaPct() {
      if (!this.staminaMax) return 0;
      return Math.min(100, (this.staminaNow / this.staminaMax) * 100);
    },
    fatiguePct() {
      if (!this.fatigueMax) return 0;
      return Math.min(100, (this.fatigueNow / this.fatigueMax) * 100);
    },
    expPct() {
      if (this.isMaxLevel) return 100;
      if (!this.userUpgradeExp) return 0;
      return Math.min(100, (this.userExp / this.userUpgradeExp) * 100);
    },
  },
  watch: {
    // 玩家属性收拢：首次获得用户信息后拉取详情/头像
    'fantasyUserBO.id': function(newId) {
      if (newId != null) {
        this.$store.dispatch('user/fetchUserDetail');
        this.$store.dispatch('user/fetchUserHeader', newId);
      }
    }
  },
  mounted() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
    // 页面刷新后 store 已初始化时补齐详情/头像
    if (this.fantasyUserBO.id != null) {
      this.$store.dispatch('user/fetchUserDetail');
      this.$store.dispatch('user/fetchUserHeader', this.fantasyUserBO.id);
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
  },
};
</script>

<style scoped>
.mobile-bottom-bar {
  position: fixed;
  bottom: 14px; left: 0;
  width: 100%;
  height: calc(var(--mobile-footer-h) - 14px);
  display: grid;
  grid-template-columns: 1fr 84px 1fr;
  z-index: 100;
  box-sizing: border-box;
  pointer-events: none;
}

.bar-left {
  grid-column: 1;
  display: flex;
  pointer-events: auto;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  overflow: hidden;
  padding: 4px 6px;
  margin-right: 8px;
  background: rgba(148, 103, 189, 0.3);
  border: 1px solid rgba(148, 103, 189, 0.2);
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.1);
  /* 底边与罗盘/快捷条对齐：它们底边在距屏 18px，卡片原位距屏 14px，抬 4px 取齐 */
  transform: translateY(-4px);
}

.bar-center {
  grid-column: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: visible;
  position: relative;
  z-index: 2;
  pointer-events: auto;
}

.bar-right {
  grid-column: 3;
  position: relative;
  z-index: 1;
  pointer-events: none;
}

.bar-left-top {
  display: flex;
  align-items: center;
  gap: 4px;
}
.name-area {
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1;
}
.name-line {
  display: flex;
  align-items: baseline;
  gap: 2px;
}
.tag-line {
  display: flex;
  gap: 4px;
}

.bar-left-mid {
  display: flex;
  gap: 4px;
  overflow: hidden;
}

/* 头像 */
.user-avatar {
  width: 50px;
  height: 66px;
  border-radius: 4px;
  overflow: hidden;
  flex-shrink: 0;
  position: relative;
}
.user-avatar.placeholder {
  background: rgba(123, 31, 162, 0.3);
  border-radius: 4px;
}
.avatar-layer {
  position: absolute;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background-size: 50px 66px;
  -moz-background-size: 50px 66px;
  background-repeat: no-repeat;
  background-position: center;
}

/* 名称 */
.user-nickname {
  color: #42a5f5;
  font-size: 12px;
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.user-account { color: #999; font-size: 9px; white-space: nowrap; }
.tag { font-size: 9px; padding: 0 3px; border-radius: 2px; white-space: nowrap; }
.tag.lv { color: #b8860b; background: rgba(184,134,11,0.12); }
.tag.money { color: #4fc3f7; }

/* 血条 */
.bar-wrap { display: flex; align-items: center; gap: 2px; min-width: 0; flex: 1; }
.bar-bg {
  flex: 1; height: 14px; border-radius: 3px;
  position: relative; min-width: 30px; overflow: hidden;
}
.bar-fill { height: 100%; border-radius: 3px; transition: width 0.3s; }
.bar-text {
  position: absolute; top: 0; left: 0;
  width: 100%; height: 100%;
  display: flex; align-items: center; justify-content: center;
  font-size: 9px; color: #fff;
  text-shadow: 0 0 2px #000; white-space: nowrap;
}
.bar-stamina { background: rgba(244,67,54,0.25); }
.bar-stamina .bar-fill { background: #f44336; }
.bar-fatigue { background: rgba(255,193,7,0.25); }
.bar-fatigue .bar-fill { background: #ffc107; }

/* 经验条：独立固定在视口最底部 */
.exp-bar-outer {
  position: fixed;
  bottom: 0; left: 0;
  width: 100%;
  height: 14px;
  padding: 1px 4px;
  padding-bottom: var(--safe-area-bottom);
  z-index: 100;
  box-sizing: border-box;
}
.bar-exp { background: rgba(76,175,80,0.25); }
.bar-exp .bar-fill { background: #4caf50; }

@media (min-width: 769px) {
  .mobile-bottom-bar,
  .exp-bar-outer { display: none; }
}
</style>
